import { render, staticRenderFns } from "./diary.vue?vue&type=template&id=764ce8b6&"
import script from "./diary.vue?vue&type=script&lang=js&"
export * from "./diary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports